const LandingPage = () => {
    return (
      <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
        <iframe
          src="https://mayapluslanding.carrd.co/"
          title="MayaPlus Landing"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    );
  };
  
  export default LandingPage;
  